<div v-if="comments.length > 0" class="tt-w-chatter">
  <div id="tt-chatter-heading" class="tt-w-chatter__heading" role="heading" :aria-level="chatterConfig.headingLevel" v-html="$msg('chatter.title')"></div>
  <tt-static-masonry-layout ref="layout" :items="comments" :breakpointsConfig="chatterConfig.breakpointsConfig" :class="'tt-w-chatter__list'">
    <template v-slot:default="{item}">
      <tt-comment :comment="item"
                  :truncateLength="chatterConfig.truncateLength"
                  :truncateAllowance="chatterConfig.truncateAllowance"
                  :key="item.id + '-' + currentPage"></tt-comment>
    </template>
  </tt-static-masonry-layout>
  <tt-pagination :currentPage="currentPage" @updatePage="pageChange" :total="total" :pageSize="limit" :contentType="$msg('chatter.paginationType')" ariaLabelledBy="tt-chatter-heading"></tt-pagination>
</div>